<template>
  <div>
    <vs-dropdown vs-custom-content vs-trigger-click class="users-actions-drop-down options-dropdown">
      <vs-icon icon-pack="speakol" icon="speakol-dots" class="adset-icon"/>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 11rem;">
          <li id="users-table-view-accounts-button" class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 hover:text-black"
              @click="$router.push({ name: 'accounts', query: {user_id: userData.id} })">
            <vs-icon icon-pack="speakol" icon="speakol-eye" svgClasses="w-5 h-5"/>
            <span class="ml-2">View Accounts</span>
          </li>
          <li id="users-table-login-button" class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 hover:text-black"
              @click="loginAs(userData.id)">
            <vs-icon icon-pack="speakol" icon="speakol-login" svgClasses="w-5 h-5"/>
            <span class="ml-2">Login</span>
          </li>

          <li id="users-table-block-button" v-if="!userData.blocked && userData.id != activeUserInfo.id" color="danger"
              class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 hover:text-red-700"
              @click="openBlockConfirmation(userData)">
            <vs-icon color="var(--danger)" icon-pack="speakol" icon="speakol-unverify" svgClasses="w-5 h-5"/>
            <span class="ml-2 text-red-700">Block</span>
          </li>
          <li id="users-table-unblock-button" v-else-if="userData.blocked && userData.id != activeUserInfo.id" class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 hover:text-red-700"
              @click="openBlockConfirmation(userData)">
            <vs-icon icon-pack="speakol" icon="speakol-edit" svgClasses="w-5 h-5"/>
            <span class="ml-2 text-red-700">Unblock</span>
          </li>

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-gray-200 hover:text-red-700"
              @click="showMigrateUserDataPopup(userData)">
            <feather-icon icon="Edit2Icon" svgClasses="w-5 h-5"/>
            <span class="ml-2 text-red-700">Migrate</span>
          </li> -->
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <div>
      <speakol-confirmation-popup
        v-on:hide-confirmation-popup="hideMigrateUserDataPopup"
        :showConfirmationPopup="migratePopup.show"
        :title="`Migrate User (${userData.name || ''})`"
        confirmationText="Start Migrating"
        cancelText="Cancel"
        v-on:confirm="migrateUserData(userData.id || '')">
        <template slot="body">
          {{ migratePopup.content }}
        </template>
      </speakol-confirmation-popup>

      <speakol-response-popup
        v-on:hide-response-popup="responsePopupData.show = false"
        :responsePopupData="responsePopupData"
      />

      <speakol-confirmation-popup
        v-on:hide-confirmation-popup="showBlockConfirmationPopup = false"
        v-on:confirm="userToBeBlocked && !userToBeBlocked.blocked ? block() : unblock()"
        :showConfirmationPopup="showBlockConfirmationPopup"
        :title="'Confirmation'"
        :body="confirmationPopupBody"
      />

    </div>
  </div>
</template>

<script>

export default {
  props: {
    userData: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data () {
    return {
      migratePopup: {},
      userToBeBlocked: null,
      showBlockConfirmationPopup: false,
      responsePopupData: {
        show: false
      }
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.getters['authentication/user'] || {}
    },

    confirmationPopupBody () {
      if (!this.userToBeBlocked) {
        return
      }

      if (this.userToBeBlocked.blocked) {
        return `Are you sure you want to unblock ${this.userToBeBlocked.name} ?`
      } else {
        return `Are you sure you want to block ${this.userToBeBlocked.name} ?`
      }
    }
  },

  watch: {

    migratePopup (newVal) {
      this.migratePopup = newVal
    },

    showBlockConfirmationPopup (newVal) {
      this.showBlockConfirmationPopup = newVal
    },
    responsePopupData (newVal) {
      this.responsePopupData = newVal
    }
  },

  beforeMount () {
    this.migratePopup = {
      show: false,
      userName: '',
      userId: '',
      content: 'are you sure you want to migrate all User Data ?'
    }
  },

  methods: {
    async migrateUserData (userId) {
      if (userId === null) {
        this.hideMigrateUserDataPopup()
      }


      await window.axios.post('/users/migrate', {
        user_id: userId
      })

      this.hideMigrateUserDataPopup()


    },

    hideMigrateUserDataPopup () {
      this.migratePopup = {
        show: false,
        userName: '',
        userId: '',
        content: 'are you sure you want to migrate all User Data ?'
      }
    },

    showMigrateUserDataPopup (userData) {
      this.migratePopup = {
        show: true,
        userName: userData.name,
        userId: userData.id,
        content: 'are you sure you want to migrate all User Data ?'
      }
    },

    async loginAs (userId) {
      const response = await window.axios.post('/users/login-as', {
        user_id: userId,
        admin_account_id: this.$store.getters['authentication/activeAccount'].id
      })

      localStorage.setItem('activeAccountId', response.data.user.accounts[0].id || null)
      localStorage.setItem('originalUser', JSON.stringify(response.data.admin || {}) || null)

      window.location.reload()
    },

    openBlockConfirmation (user) {
      this.userToBeBlocked = user
      this.showBlockConfirmationPopup = true
    },

    async block () {

      if (!this.userToBeBlocked) {
        return
      }

      try {
        await window.axios.post(`/users/${this.userToBeBlocked.id}/block`)
        this.userToBeBlocked.blocked = true
        this.showBlockConfirmationPopup = false
        this.successToggleBlock()
      } catch (error) {
        this.failToggleBlock()
      }

    },

    async unblock () {
      if (!this.userToBeBlocked) {
        return
      }

      try {
        await window.axios.post(`/users/${this.userToBeBlocked.id}/unblock`)
        this.userToBeBlocked.blocked = false
        this.showBlockConfirmationPopup = false
        this.successToggleBlock()
      } catch (error) {
        this.failToggleBlock()
      }

    },

    successToggleBlock () {
      if (!this.userToBeBlocked) {
        return
      }

      this.responsePopupData.show = true
      this.responsePopupData.type = 'success'
      this.responsePopupData.body = `You have successfully ${this.userToBeBlocked.blocked ? 'blocked' : 'unblocked'} ${this.userToBeBlocked.name}`
    },

    failToggleBlock () {
      this.responsePopupData.show = true
      this.responsePopupData.type = 'error'
      this.responsePopupData.body = 'Something went wrong!'
    }
  }
}
</script>

<style lang="scss">
.users-actions-drop-down {
  cursor: pointer;
}
</style>
